// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--05f1e";
export var button = "styles-module--button--765c0";
export var button___desktop = "styles-module--button___desktop--45bc3";
export var button___mobile = "styles-module--button___mobile--a256e";
export var card = "styles-module--card--28867";
export var info = "styles-module--info--39583";
export var pulse = "styles-module--pulse--61f2b";
export var text = "styles-module--text--f3435";